
import { connect } from 'react-redux'
import SidePanelContent from './SidePanelContent'
import { State } from '../../dataStore/reducers/reducerType'

const mapStateToProps = (state: State) => ({
  debug: state.config.debug,
  featureFlags: state.config.featureFlags
})

export default connect(mapStateToProps)(SidePanelContent)
